window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); window.__zvPrompt = e; });
// Evita que el teclado se abra solo al abrir la app o al salir: ningún campo recibe foco hasta que el usuario toque la pantalla.
(() => {
  let acted = false;
  const act = () => { acted = true; };
  ["pointerdown", "touchstart", "mousedown", "keydown"].forEach((ev) => window.addEventListener(ev, act, { capture: true, passive: true }));
  window.addEventListener("pageshow", () => { acted = false; });
  document.addEventListener("focusin", (e) => {
    if (acted || /^\/(scan|kiosk)/.test(window.location.pathname)) return;
    const t = e.target;
    if (t?.matches?.("input:not([type=checkbox]):not([type=radio]):not([type=button]), textarea, [contenteditable=true]")) t.blur();
  }, true);
})();
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Registrar el Service Worker SIEMPRE al abrir la app (no solo al activar notificaciones).
// Usa estrategia "network-first" para HTML/JS/CSS, por lo que cada redeploy carga la ÚLTIMA
// versión y nunca se queda código viejo en caché en las computadoras del colegio.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
